<template>

    <static-vanilla :page="pageName"></static-vanilla>

</template>

<script>
import UserFlow from '@/modules/userFlow'

import StaticVanilla from '@/components/StaticVanilla'
import Update from '@/modules/update'

export default {

    name: 'terms',

    components: {StaticVanilla},

    data () {
        return  {
            pageName: 'terms'
        }
    },

    mounted() {
        UserFlow.setPage(this, this.pageName)
        Update.terms.accept()
    }
}
</script>